module.exports = __webpack_public_path__ + "img/1588621417.0ef4a973.jpg";